import { getStatePure, modifyState } from '~src/state';
import { deleteTmpAnimationObject } from '~video';

export const deleteAnimationsByObjRefId = (obj) => {
  const pages = getStatePure('pages');
  if (!obj.giotto) {
    return;
  }
  const { objRefId } = obj.giotto;

  for (let pageIndex = 0; pageIndex < pages.length; pageIndex++) {
    if (!pages[pageIndex].animations) {
      continue;
    }
    const newAnimations = pages[pageIndex].animations.reduce(
      (acc, animation) => {
        const newObjects = animation.objects.filter((id) => id !== objRefId);
        if (newObjects.length > 0) {
          const newAnimation = {
            ...animation,
            objects: newObjects,
          };
          acc.push(newAnimation);
        }

        return acc;
      },
      []
    );

    pages[pageIndex].animations = newAnimations;
  }

  // TODO: make async
  modifyState('pages', pages);
  deleteTmpAnimationObject();
};
